import $ from 'jquery'
import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'
import { debounce, getTextNodesIn } from '../functions'

imagesLoaded.makeJQueryPlugin($)

let partnerTypes = $('[data-types]').attr('data-types')
if (partnerTypes != undefined) {
    partnerTypes = partnerTypes.split(',')

    let isoPart = []

    $.each(partnerTypes, function () {
        let isoPartTemp = ''
        const parent = $('.js-container-' + this)
        if (parent.length) {
            isoPartTemp = new Isotope('.js-container-' + this, {
                itemSelector: '.js-iso-item',
                transitionDuration: 0,
                percentPosition: true,
                masonry: {
                    columnWidth: 33,
                },
            })
        }

        const search = $('.js-search-iso').keyup(
            debounce(function () {
                const qsRegex = new RegExp(search.val(), 'gi')

                isoPartTemp.arrange({
                    filter: function () {
                        const post = $(this)
                        const text = getTextNodesIn(post[0])

                        let hasText = qsRegex ? text.match(qsRegex) : true

                        return hasText
                    },
                })
            }, 200)
        )

        search.on('blur', function () {
            const qsRegex = new RegExp(search.val(), 'gi')

            isoPartTemp.arrange({
                filter: function () {
                    const post = $(this)
                    const text = getTextNodesIn(post[0])

                    let hasText = qsRegex ? text.match(qsRegex) : true

                    return hasText
                },
            })
        })

        isoPart.push(isoPartTemp)
    })
}

let catIso = ''

const parent = $('.js-cat-iso')
if (parent.length != 0) {
    catIso = new Isotope('.js-cat-iso', {
        itemSelector: '.js-cat-iso-item',
        percentPosition: true,
        transitionDuration: 0,
        layoutMode: 'fitRows',
    })

    parent.imagesLoaded(function () {
        catIso.layout()
    })

    $('.js-select-iso').on('change', function () {
        const vals = [$(this).val()]

        if (vals.length === 0) {
            catIso.arrange({ filter: '*' })
            return
        }

        catIso.arrange({
            filter: function () {
                const posts = $(this)

                const attr = posts.attr('data-categories')
                const categories = attr.includes(',') ? attr.split(',') : [attr]
                const newCategories = categories.map(Number)
                let hasCategory = false

                if (newCategories.length > 0) {
                    for (let i = 0; i < vals.length; i++) {
                        if (
                            newCategories.includes(parseInt(vals[i])) ||
                            vals[i] === 'all'
                        ) {
                            hasCategory = true
                        }
                    }
                }

                const post = $(this)
                const text = getTextNodesIn(post[0])
                const qsRegex = new RegExp($('.js-search-iso').val(), 'gi')

                let hasText = qsRegex ? text.match(qsRegex) : true

                return hasCategory && hasText
            },
        })
    })
}

const search = $('.js-search-iso').keyup(
    debounce(function () {
        const qsRegex = new RegExp(search.val(), 'gi')
        const vals = [$('.js-select-iso').val()]

        catIso.arrange({
            filter: function () {
                const partner = $(this)

                const attr = partner.attr('data-categories')
                const categories = attr.includes(',') ? attr.split(',') : [attr]
                const newCategories = categories.map(Number)
                let hasCategory = false

                if (vals[0] == null) {
                    hasCategory = true
                }

                if (newCategories.length > 0) {
                    for (let i = 0; i < vals.length; i++) {
                        if (
                            newCategories.includes(parseInt(vals[i])) ||
                            vals[i] === 'all'
                        ) {
                            hasCategory = true
                        }
                    }
                }

                const post = $(this)
                const text = getTextNodesIn(post[0])

                let hasText = qsRegex ? text.match(qsRegex) : true

                return hasCategory && hasText
            },
        })
    }, 200)
)

search.on('blur', function () {
    const qsRegex = new RegExp(search.val(), 'gi')
    const vals = [$('.js-select-iso').val()]

    catIso.arrange({
        filter: function () {
            const partner = $(this)

            const attr = partner.attr('data-categories')
            const categories = attr.includes(',') ? attr.split(',') : [attr]
            const newCategories = categories.map(Number)
            let hasCategory = false

            if (vals[0] == null) {
                hasCategory = true
            }

            if (newCategories.length > 0) {
                for (let i = 0; i < vals.length; i++) {
                    if (newCategories.includes(parseInt(vals[i])) || vals[i] === 'all') {
                        hasCategory = true
                    }
                }
            }

            const post = $(this)
            const text = getTextNodesIn(post[0])

            let hasText = qsRegex ? text.match(qsRegex) : true

            return hasCategory && hasText
        },
    })
})
